<mat-dialog-content class="content-dialog">
  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-text">Invite to apply</div>
      <button
        mat-flat-button
        class="md circle"
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div
      class="dialog-content"
      [formGroup]="form"
    >
      <div class="search-input">
        <mojo-autocomplete
          (inputChange)="onInputChange($event)"
          formControlName="job"
          label="Search for job name or job ID"
          placeholder=""
          [multi]="false"
          [useChips]="false"
          [options]="jobs$ | async"
          bindLabel="label"
          appearance="fill"
          color="accent"
        ></mojo-autocomplete>
      </div>
      <div
        class="job-link-loader"
        *ngIf="linkLoading"
      >
        <mojo-loader></mojo-loader>
      </div>
      <div
        class="job-link"
        *ngIf="!linkLoading && (link$ | async) as link"
      >
        Job link: <a
          [href]="link"
          target="_blank"
        >{{link}}</a>
      </div>
      <div class="modal-buttons">
        <button
          color="accent"
          class="mr-2"
          mat-button
          type="button"
          (click)="closeDialog()"
        >Cancel
        </button>
        <button
          color="primary"
          class="md"
          mat-flat-button
          type="button"
          [disabled]="form.invalid || linkLoading"
          (click)="onInvite()"
        >INVITE
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
